import React, { createContext, useContext } from 'react';
import { useStore as zustandUseStore } from 'zustand';

const StoresContext = createContext(null);

export function StoresProvider({ children, value }) {
    return React.createElement(StoresContext.Provider, { value }, children);
}

function useStores() {
    const ctx = useContext(StoresContext);
    if (!ctx) throw new Error('StoresProvider is missing above this component');
    return ctx;
}

export function useFlowStore(selector, equalityFn) {
    const { flowStore } = useStores();
    return zustandUseStore(flowStore, selector, equalityFn);
}

export function useUiStore(selector, equalityFn) {
    const { uiStore } = useStores();
    return zustandUseStore(uiStore, selector, equalityFn);
}

export function useSessionStore(selector, equalityFn) {
    const { sessionStore } = useStores();
    return zustandUseStore(sessionStore, selector, equalityFn);
}

export function useSyncBridge() {
    return useStores().syncBridge;
}

export function useFlowStoreInstance() {
    return useStores().flowStore;
}

export function useSessionStoreInstance() {
    return useStores().sessionStore;
}

export function useFlowRegistry() {
    return useStores().flowRegistry;
}

export function useFlowEvents() {
    return useStores().flowEvents;
}
